<div class="h-30"></div>
<div class="caseFileTableContainer allFilesContainer" [hidden]="false">
  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="expansion-panel-header">
            <label class="title">Audit Logs</label>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <!-- Content for Panel 1 -->


      <div class="h-30"></div>
      <div class="tableContents">
		<ng-container #allFilesTable *ngTemplateOutlet="
        raAuditTable;
        context: { data: auditLogs, headerVisible: true }
        "></ng-container>
        <!-- <mat-paginator #allFilesPaginator [length]="this.totalRecords" [pageSize]="10"
      [pageSizeOptions]="[10, 25, 50]" (page)="pageEvent = $event" ariaLabel=''></mat-paginator> -->
    </div>


    <ng-template #raAuditTable let-data="data" let-headerVisible="headerVisible">
      <table mat-table class="fileList primary" [dataSource]="data">
        <ng-container matColumnDef="User">
          <th mat-header-cell *matHeaderCellDef class="roundedLeft" sortActionDescription="Sort by File ID">
            User
          </th>
          <td mat-cell *matCellDef="let auditLogs">
          {{ auditLogs.user }}</td>
        </ng-container>

        <ng-container matColumnDef="Date">
          <th mat-header-cell *matHeaderCellDef class="roundedLeft" sortActionDescription="Sort by Date">
            Date
          </th>
          <td mat-cell *matCellDef="let auditLogs">{{ auditLogs.date| date : "dd/MM/yyyy HH:mm" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="Event">
          <th mat-header-cell *matHeaderCellDef class="roundedLeft" sortActionDescription="Sort by Date">
            Event
          </th>
          <td mat-cell *matCellDef="let auditLogs">{{ enumdescservice.getDescription(auditLogs.auditEventType)}}
          </td>
        </ng-container>

        <ng-container matColumnDef="Details">
          <th mat-header-cell *matHeaderCellDef class="roundedLeft" sortActionDescription="Sort by Name">
            Details
          </th>
          <td mat-cell *matCellDef="let auditLogs">
            <table class="nestedtable">
              @if (auditLogs.changes.length>0) {
                <tr>
                  <th> Field Name</th><th>Old Value</th><th>New Value</th>
                </tr>
              }
              @for (change of auditLogs.changes; track change) {
                @if (!change.hidden) {
                  <tr>
                    <td>{{change.fieldName}}</td><td>{{checkIfValidDate(change.oldValue)}}</td><td>{{checkIfValidDate(change.newValue)}}</td>
                  </tr>
                }
              }
            </table>

          </td>
        </ng-container>

        @if (headerVisible) {
          <tr mat-header-row *matHeaderRowDef="columnsToDisplay" class="tableHeader"></tr>
        }
        <tr mat-row *matRowDef="let rfiForm; columns: columnsToDisplay"></tr>
      </table>
    </ng-template>
  </mat-expansion-panel>
</mat-accordion>
</div>
